import { render, staticRenderFns } from "./ProductSummaryCard.vue?vue&type=template&id=ba6d06dc&scoped=true"
import script from "./ProductSummaryCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductSummaryCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductSummaryCard.vue?vue&type=style&index=0&id=ba6d06dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6d06dc",
  null
  
)

export default component.exports